import React, {Component} from "react";
import {Provider} from "react-redux";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-tooltip/dist/react-tooltip.css";
import "react-sliding-pane/dist/react-sliding-pane.css";

import store from "store";
import {ScrollToTop} from "components";
import AppContainer from "AppContainer";
import "./styles/global.scss";

class App extends Component<React.PropsWithChildren<NonNullable<unknown>>, NonNullable<unknown>> {
	constructor(props: React.PropsWithChildren<NonNullable<unknown>>) {
		super(props);
	}

	render() {
		return (
			<Provider store={store}>
				<AppContainer />
				<ToastContainer
					limit={3}
					autoClose={5000}
					closeButton={false}
					containerId="toast-container"
					draggable
					hideProgressBar={false}
					icon={false}
					newestOnTop={true}
					pauseOnFocusLoss
					pauseOnHover
					position="top-right"
					theme="light"
				/>
				<ScrollToTop />
			</Provider>
		);
	}
}

export default App;
